export enum MemberType {
  USER = "USER",
  SHOP = "SHOP",
}

export enum MemberStatus {
  ACTIVE = "ACTIVE",
  BLOCK = "BLOCK",
  DELETE = "DELETE",
}
